import { DateTime, Settings } from "luxon";

/**
 * Frontend timezone service for managing salon-specific timezone handling
 */
export const TimezoneService = {
  /**
   * Set the global default timezone for Luxon based on salon data
   * This affects all DateTime operations in the current context
   */
  setSalonTimezone(timezone: string, _salonId?: string): void {
    // Validate the timezone
    const testDateTime = DateTime.local().setZone(timezone);
    if (!testDateTime.isValid) {
      throw new Error(`Invalid timezone: ${timezone}`);
    }

    // Set the global default timezone
    Settings.defaultZone = timezone;
  },
};
